
export class DocumentUtil {

    public static displayDocument(content: string, fileName?: string): void {
        const blob: Blob = this.createBlob(content);
        const navigator = (window.navigator as any);
        if (navigator && navigator.msSaveOrOpenBlob) {
            // Internet explorer support.
            navigator.msSaveOrOpenBlob(blob, fileName ? fileName : 'application.pdf');
        } else {
            // Other browsers.
            const url: string = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
            // A delay before resource is removed.
            setTimeout(() => URL.revokeObjectURL(url), 100);
        }
    }

    private static createBlob(content: string): Blob {
        const byteArray: number[] = atob(content)
            .split('')
            .map((c) => c.charCodeAt(0));
        const intArray: Uint8Array = new Uint8Array(byteArray);
        return new Blob([intArray.buffer as ArrayBuffer], { type: 'application/pdf' });
    }
}

